import { ApiError } from "@vana/core";

export class ListCapturesError extends ApiError {}
export class UploadCaptureError extends ApiError {}
export class RemoveCaptureError extends ApiError {}
